import type { FaireProductEntity } from "../../entity_types/product";

export const p_dxxios8k7k: FaireProductEntity = {
  token: "p_dxxios8k7k",
  type: "product",
  name: "Lavender Infused Honey",
  brandToken: "b_5yoaobuy2a",
  brandName: "Naturacentric",
  imageUrl:
    "https://cdn.faire.com/fastly/3edbca1dc6779e1248fb740fab6ba46f32aebcac11a8cbae53addecbe6229de6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/370ad222380773026a035b766fc3251988b5c284e1340fc29612a49dd552cc98.jpeg",
    "https://cdn.faire.com/fastly/1149be4efef31a050c62cfea89436ccb09313c5be0913f5d72ad1bde892823dc.jpeg",
    "https://cdn.faire.com/fastly/8feb1e94c96376b4d8a309436ad3d29b80eed37553beb96f2dab5c7623a29e7f.jpeg",
    "https://cdn.faire.com/fastly/0c8a12b83e804826f1c44e9e56cb80659b528c05f0241570309274b346495e97.jpeg",
    "https://cdn.faire.com/fastly/5332ab11d8b9d17c1f682749c868d2fa8d11d554a65cdf94a4b072deedaa76f0.jpeg",
  ],
  priceDollars: 8.31,
  description:
    "This Hazy Raw Local Honey is paired with Lavender flowers.\n\nTASTE Herbaceous, Floral, Buttery and Sweet. \n\nPAIRS wonderfully with Goat Cheese. Drizzle over ice cream, smoothie bowls, parfaits, plain yogurt and kefirs. Pancakes, waffles, biscuits, butter croissants. Vinaigrette Salad Dressing. Lavender Lemonade. Healthy Cocktails.  Makes a wonderful sweetener for tea, adds another depth of flavor as well as medicinal properties.\n\nBENEFITS Helpful for relaxation and improved sleep. Anxiety and Mood. Anti-inflammatory properties. Topically it helps with dry itchy skin, improves eczema and acne.",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:53.790Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
